import { createContext } from 'react';
var RowContext = createContext({});
export default RowContext;